module.exports = __webpack_public_path__ + "img/lg_ring_g_i_1_null@3x.ee0eef4c.png";